export default function check_gdpr() {
  if ($('.wl-contact-form')) {
    $('.wl-contact-form').on('submit', function(e) {
      if ($('.gdpr-checkbox', this).length > 0 && !$('.gdpr-checkbox', this).prop('checked')) {
        e.preventDefault();
        alert('Du måste godkänna villkoren i enlighet med integritetspolicyn');
      }
    });
  }
}
